/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type userGeoInfo_regionalInfo = {
    readonly zipCode: string | null;
    readonly countryCode: string | null;
    readonly incomeLevel: {
        readonly incomeBracket: string | null;
        readonly incomePercentile: string | null;
    } | null;
    readonly " $refType": "userGeoInfo_regionalInfo";
};
export type userGeoInfo_regionalInfo$data = userGeoInfo_regionalInfo;
export type userGeoInfo_regionalInfo$key = {
    readonly " $data"?: userGeoInfo_regionalInfo$data;
    readonly " $fragmentRefs": FragmentRefs<"userGeoInfo_regionalInfo">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "userGeoInfo_regionalInfo",
  "type": "RegionalInfo",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "zipCode",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "zipCode",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "countryCode",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "incomeLevel",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "zipCode",
          "variableName": "zipCode"
        }
      ],
      "concreteType": "IncomeLevel",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "incomeBracket",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "incomePercentile",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '808089ad4770f3df1c5bafe793469cfb';
export default node;
